type MembersAreaSectionRequest = {
  endpoint: string;
  nonce: string;
  planId: number;
  section: string;
  page: number;
  sortBy?: string;
  sortOrder?: string;
};

export type MembersAreaSectionResponse = {
  planId: number;
  section: string;
  page: number;
  maxPages: number;
  html: string;
};

export async function fetchMembersAreaSection(
  request: MembersAreaSectionRequest,
  signal?: AbortSignal
): Promise<MembersAreaSectionResponse> {
  const endpointUrl = new URL(request.endpoint, window.location.origin);
  endpointUrl.searchParams.set('plan_id', String(request.planId));
  endpointUrl.searchParams.set('section', request.section);
  endpointUrl.searchParams.set('page', String(request.page));

  if (request.sortBy) {
    endpointUrl.searchParams.set('sort_by', request.sortBy);
  }

  if (request.sortOrder) {
    endpointUrl.searchParams.set('sort_order', request.sortOrder);
  }

  const response = await fetch(endpointUrl.toString(), {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'X-WP-Nonce': request.nonce,
    },
    signal,
  });

  if (!response.ok) {
    throw new Error(`Membership section request failed (${response.status})`);
  }

  const payload = (await response.json()) as MembersAreaSectionResponse;

  if (!payload || typeof payload.html !== 'string') {
    throw new Error('Invalid membership section payload.');
  }

  return payload;
}

